import React from 'react';
import { toast } from 'react-toastify';
import type { SnackbarProps } from 'components-stateless/DesignSystem/Atoms/Snackbar';
import Snackbar from 'components-stateless/DesignSystem/Atoms/Snackbar';

const AUTO_CLOSE_TIMEOUT_DEFAULT = 5000;
const AUTO_CLOSE_TIMEOUT_WITH_ACTION = 10000;

type NotifyParams = Omit<SnackbarProps, 'id' | 'style'> & {
  isSticky?: boolean;
};

export const notify = ({
  message,
  htmlMessage,
  onClose,
  isCloseable = true,
  isSticky = false,
  size = 'Medium',
  type,
  actionButtonText,
  onClickActionButton,
}: NotifyParams) => {
  if (!message && !htmlMessage) {
    return;
  }

  let autoClose: number | boolean = AUTO_CLOSE_TIMEOUT_DEFAULT;

  if (actionButtonText && onClickActionButton) {
    autoClose = AUTO_CLOSE_TIMEOUT_WITH_ACTION;
  }

  if (isSticky) {
    autoClose = false;
  }

  toast(
    <Snackbar
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(message ? { message } : { htmlMessage: htmlMessage as string })}
      size={size}
      type={type}
      isCloseable={isCloseable}
      onClose={onClose}
      actionButtonText={actionButtonText}
      onClickActionButton={onClickActionButton}
    />,
    {
      autoClose,
      onClose,
    }
  );
};
